import { HttpAuth, HttpUpload } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeScreen } from './navigation.action'
import { changeNotify } from './notify.action'
import { change as changeVerifySms } from './sms.action'

export const actionTypes = {
    INDEX: 'APP_INDEX',
    UPDATE: 'APP_UPDATE',
    CHANGE: 'APP_CHANGE',
    CHANGE_THEME: 'APP_CHANGE_THEME',
    CHANGE_USER: 'APP_CHANGE_USER',
    ERROR: 'APP_ERROR',
    SUCCESS: 'APP_SUCCESS'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const changeTheme = (payload) => ({
    type: actionTypes.CHANGE_THEME,
    payload
})

export const changeUser = (payload) => ({
    type: actionTypes.CHANGE_USER,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

/* LOGOUT */

export const logout = (all = null) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.get('/logout'+ (all ? '/all' : ''))
            .then(res => {
                dispatch(changeLoading({ open: false }))
                
                if(typeof res !== 'undefined') {
                    if(res.data.success === 200) {
                        dispatch(changeNotify({
                            open: true,
                            msg: res.data.msg,
                            class: 'success'
                        }))
                        localStorage.removeItem('access_token')
                        setTimeout(() => window.location.replace('/login'), 1500)
                    }
                }
            })
}

// INDEX

export const indexResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const index = () => dispatch => {
    return HttpAuth.get('/app')
            .then(res => res && dispatch(indexResponse(res.data)))
}

/* UPDATE USER */

export const updateUser = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.put('/user', data)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    setTimeout(() => {
                        dispatch(success(true))
                        dispatch(changeUser({password: ''}))
                    }, 1000)
                }
            }
        })
        .catch(erro => {
            if(erro.response) {
                if(erro.response.data.error) {
                    dispatch(error(erro.response.data.error))
                }
            }
            dispatch(changeLoading({ open: false }))
        })
}